<div [class]="containerClass">
    <!-- Loading spinner -->
    <div *ngIf="isLoadingState" class="state-icon">
        <mat-spinner diameter="40"></mat-spinner>
    </div>

    <!-- Icon for empty/error states -->
    <mat-icon *ngIf="showIcon" class="state-icon">
        {{ currentIcon }}
    </mat-icon>

    <!-- Message -->
    <p class="state-text">
        {{ currentMessage }}
    </p>

    <!-- Slot for custom content -->
    <ng-content></ng-content>
</div>
